import { render, staticRenderFns } from "./myAccountlistEdit.vue?vue&type=template&id=3b138eff&scoped=true&"
import script from "./myAccountlistEdit.vue?vue&type=script&lang=js&"
export * from "./myAccountlistEdit.vue?vue&type=script&lang=js&"
import style0 from "./myAccountlistEdit.vue?vue&type=style&index=0&id=3b138eff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b138eff",
  null
  
)

export default component.exports